module.exports = __webpack_public_path__ + "static/img/agree-bg.b2f5059.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grade/agree-bg.png
// module id = 118+
// module chunks = 1